import React from "react";

import { styled } from "styled-components";

import { colorTheme, gridSpacing } from "@utils";

import TableLink from "../Table/TableLink";

const BreadCrumbContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${gridSpacing[4]}px;
`;

const BreadCrumb = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  i {
    color: ${colorTheme("neutralL3")};
    margin-right: ${gridSpacing[2]}px;
    font-size: 16px;
  }
`;

const Divider = styled.div`
  color: ${colorTheme("neutralL3")};
  font-size: 16px;
  font-weight: 500;
`;

type RouteProps = {
  icon?: string;
  iconStyle?: React.CSSProperties;
  breadcrumb: React.ReactNode;
  path?: string;
  onClick?: () => void;
};

type BreadCrumbsProps = {
  baseRoute?: RouteProps;
  routes?: RouteProps[];
  style?: React.CSSProperties;
};

const BreadCrumbs = ({ baseRoute, routes, style }: BreadCrumbsProps) => (
  <BreadCrumbContainer style={style}>
    {baseRoute && (
      <>
        <BreadCrumb>
          {baseRoute.icon && (
            <i style={baseRoute.iconStyle} className={baseRoute.icon} />
          )}
          {baseRoute.path || baseRoute.onClick ? (
            <TableLink onClick={baseRoute.onClick} url={baseRoute.path}>
              {baseRoute.breadcrumb}
            </TableLink>
          ) : (
            <div style={{ color: colorTheme("neutralL1") }}>
              {baseRoute.breadcrumb}
            </div>
          )}
        </BreadCrumb>
        {routes && routes.length > 0 && <Divider>|</Divider>}
      </>
    )}
    {routes?.map(
      ({ icon, breadcrumb, path, onClick, iconStyle }, headerIndex) => (
        <React.Fragment key={headerIndex}>
          {headerIndex !== 0 && headerIndex !== routes.length && (
            <Divider>/</Divider>
          )}
          <BreadCrumb>
            {icon && <i style={iconStyle} className={icon} />}
            {headerIndex + 1 !== routes.length && (path || onClick) ? (
              <TableLink
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                onClick={onClick}
                url={path}
              >
                {breadcrumb}
              </TableLink>
            ) : (
              <div
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  color: colorTheme("neutralL1"),
                }}
              >
                {breadcrumb}
              </div>
            )}
          </BreadCrumb>
        </React.Fragment>
      ),
    )}
  </BreadCrumbContainer>
);

export default BreadCrumbs;
